import React from 'react'
import Collabrat from '../Image/Collabrat.svg'
import { BsArrowRightCircleFill } from "react-icons/bs";
import Ecell from '../Image/Ecell.png'
import classplus from '../Image/classplus.png'
import webd from '../Image/webd.png'
import NIMBUS from '../Image/NIMBUS.png'
function Collabration() {
  return (
    <div>

      {/* ------------------Desktop view------------------ */}
      <div className='container  pt-2 d-none d-md-block'>
        <div className='row mt-5'>
            <div className='col-md-6 pt-5'>
                <div className='pt-3 collabration_text'>
                <h1 className='display-6 fw-bold'>
                Unleashing Success Through Dynamic Collaborations!
                    </h1>
                    <p className='fs-5 mt-4'>Experience synergy in action! Explore our impactful partnerships with industry leaders, fostering innovation and creating unparalleled opportunities for growth. Join us on the path to collective success</p>
                </div>
            </div>
            <div className='col-md-6 pt-2 px-5'>
                <div className='row collabration_img'>
                  <div className='col-md-6 text-center border-end border-bottom'>
                    <img className='Ecell pt-4 pb-1' src={Ecell}></img>
                  </div>
                  <div className='col-md-6 text-center border-start border-bottom'>
                  <img className='pb-1' src={NIMBUS}></img>
                  </div>
                  <div className='col-md-12 text-center border-bottom'>
                  <img className='py-3' src={classplus}></img>
                  </div>
                  <div className='col-md-6 text-center border-end'>
                  <img className='Ecell pt-3' src={webd}></img>
                  </div>
                  <div className='col-md-6 text-center border-start'>
                  <img src={'https://www.snsoft.tech/static/logo-new.png'}></img>
                  </div>
                </div>
            </div>
        </div>
      </div>

      {/* -----------------------Mobile view------------------- */}

      <div className='container-fluid pt-4 d-sm-block d-md-none'>
        <div className='row'>
          <div className='collabration_text text-center'>
          <h1 className='fs-5'>
          Unleashing Success Through Dynamic Collaborations!
              </h1>
          </div>
          <div className='col-12  px-5 pt-4 pb-2'>
                <div className='d-flex justify-content-center'>
                <div className='row collabration_img'>
                  <div className='col-md-6 text-center border-end border-bottom'>
                    <img className='Ecell pt-3 pb-1' src={Ecell}></img>
                  </div>
                  <div className='col-md-6 text-center border-start border-bottom'>
                  <img src={NIMBUS}></img>
                  </div>
                  <div className='col-md-6 py-2 text-center border-end border-bottom'>
                  <img className='Ecell py-1' src={webd}></img>
                  </div>
                  <div className='col-md-6 py-3 text-center border-start border-bottom'>
                  <img className='Ecell pt-1' src={classplus}></img>
                  </div>
                  <div className='col-md-6 text-center border-end'>
                  <img src={'https://www.snsoft.tech/static/logo-new.png'}></img>
                  </div>
                </div>
                </div>
              <p className='mt-3 text-center mobile_collabration_text_p'>Experience synergy in action! Explore our impactful partnerships with industry leaders, fostering innovation and creating unparalleled opportunities for growth. Join us on the path to collective success</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Collabration
